import authorizedAxios from "../../helpers/authorizedAxios";
import { showToast, showAlert } from "../../utils/helpers/ShowToast";
import { getReadableApiError } from "../../utils/helpers/apiError";
export const SET_ACCOUNTS = "SET_ACCOUNTS";
export const SET_ACCOUNT = "SET_ACCOUNT";
export const SET_ACCOUNTS_LOADING = "SET_ACCOUNTS_LOADING";
export const SET_ACCOUNTS_ERROR = "SET_ACCOUNTS_ERROR";

export const fetchAccounts = (limit = 250, page = 1, search = "") => {
  return async (dispatch) => {
    dispatch({ type: SET_ACCOUNTS_LOADING, status: true });

    try {
      const response = await authorizedAxios.get("/users", {
        params: {
          limit,
          page,
          search: search || undefined,
        },
      });

      if (response.status === 200 || response.status === 201) {
        dispatch({
          type: SET_ACCOUNTS,
          data: response?.data?.data,
        });
      }
    } catch (error) {
      console.error("error", error);
      dispatch({
        type: SET_ACCOUNTS_ERROR,
        error: error?.response?.data || "Terjadi kesalahan saat mengambil data.",
      });
    } finally {
      dispatch({ type: SET_ACCOUNTS_LOADING, status: false });
    }
  };
};

export const getAccountById = (id) => {
  return async (dispatch) => {
    dispatch({ type: SET_ACCOUNTS_LOADING, status: true });

    try {
      const response = await authorizedAxios.get("/users/" + id);

      if (response.status === 200 || response.status === 201) {
        dispatch({
          type: SET_ACCOUNT,
          data: response.data,
        });
      }
    } catch (error) {
      console.error("error", error);
      dispatch({
        type: SET_ACCOUNTS_ERROR,
        error: error?.response?.data || "Terjadi kesalahan saat mengambil data.",
      });
    } finally {
      dispatch({ type: SET_ACCOUNTS_LOADING, status: false });
    }
  };
};

export const addAccount = (data, refreshOptions = {}) => {
  return async (dispatch) => {
    dispatch({ type: SET_ACCOUNTS_LOADING, status: true });

    try {
      const response = await showToast(authorizedAxios.post("/users", data), {
        loading: "Menyimpan data...",
        success: "Data akun berhasil ditambahkan!",
        error: (err) => err?.response?.data?.message || "Gagal menyimpan data!",
      });
      if (response.status === 200 || response.status === 201) {
        dispatch(fetchAccounts(refreshOptions.limit, refreshOptions.page, refreshOptions.search));

        return true;
      }
    } catch (error) {
      console.error("error", error);
      dispatch({
        type: SET_ACCOUNTS_ERROR,
        error: getReadableApiError(error, "Data akun gagal disimpan."),
      });
      return false;
    } finally {
      dispatch({ type: SET_ACCOUNTS_LOADING, status: false });
    }
  };
};

export const deleteAccount = (id, refreshOptions = {}) => {
  return async (dispatch) => {
    dispatch({ type: SET_ACCOUNTS_LOADING, status: true });

    try {
      const response = await showToast(authorizedAxios.delete(`/users/${id}`), {
        loading: "Menghapus data...",
        success: "Data akun berhasil dihapus!",
        error: (err) => err?.response?.data?.message || "Gagal menghapus data!",
      });
      if (response.status === 200 || response.status === 201) {
        dispatch(fetchAccounts(refreshOptions.limit, refreshOptions.page, refreshOptions.search));

        showAlert({
          type: "success",
          message: "Data akun berhasil dihapus!",
        });

        return true;
      }
      return false;
    } catch (error) {
      console.error("error", error);
      dispatch({
        type: SET_ACCOUNTS_ERROR,
        error: error?.message || "Terjadi kesalahan.",
      });
      return false;
    } finally {
      dispatch({ type: SET_ACCOUNTS_LOADING, status: false });
    }
  };
};

export const updateAccount = (id, data, refreshOptions = {}) => {
  return async (dispatch) => {
    dispatch({ type: SET_ACCOUNTS_LOADING, status: true });

    try {
      const response = await showToast(authorizedAxios.put(`/users/${id}`, data), {
        loading: "Memperbarui data...",
        success: "Data akun berhasil diperbarui!",
        error: (err) => err?.response?.data?.message || "Gagal memperbarui data!",
      });
      if (response.status === 200 || response.status === 201) {
        dispatch(fetchAccounts(refreshOptions.limit, refreshOptions.page, refreshOptions.search));

        return true;
      }
    } catch (error) {
      console.error("error", error);
      dispatch({
        type: SET_ACCOUNTS_ERROR,
        error: getReadableApiError(error, "Data akun gagal diperbarui."),
      });
      return false;
    } finally {
      dispatch({ type: SET_ACCOUNTS_LOADING, status: false });
    }
  };
};
